import { render, staticRenderFns } from "./BankPayway.vue?vue&type=template&id=18d406e5&scoped=true&"
import script from "./BankPayway.vue?vue&type=script&lang=js&"
export * from "./BankPayway.vue?vue&type=script&lang=js&"
import style0 from "./BankPayway.vue?vue&type=style&index=0&id=18d406e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d406e5",
  null
  
)

export default component.exports